import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const textFieldStyles: Record<string, SxProps> = {
  base: {
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '0.875rem',
    width: '100%',
    // style applied on input text on normal state
    '.MuiOutlinedInput-input': {
      color: `${palette.darkestBlack.main} !important`,
      zIndex: '0',
      '&:focus': {
        color: `${palette.darkestBlack.main} !important`
      }
    },
    // to style readOnly field
    '& .MuiInput-input': {},
    // color when in simple state
    '& .MuiInput-underline:before': {
      borderBottom: `0.0625rem solid ${palette.grey.main}`,
      opacity: '0.1'
    },
    // color when field is focused
    '& .MuiInput-underline:after': {
      borderBottom: `0.0625rem solid ${palette.faintAqua.main}`
    },
    // color on hover state
    '& .MuiInput-underline:hover:not(.Mui-disabled)::before': {
      borderBottom: `0.0625rem solid ${palette.grey.main}`
    },

    // style applied to title in normal state
    label: {
      color: palette.primary['300'],
      textTransform: 'uppercase'
    },
    // style applied to title when field is focused
    '& label.Mui-focused': {
      color: palette.primary['300'],
      textTransform: 'uppercase'
    },
    // style applied to base state and hover and focus state
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: `${palette.secondary['600']} !important`,
        backgroundColor: 'transparent',
        color: palette.grey.main
      },
      '&:hover fieldset': {
        borderColor: palette.primary['200'],
        color: `${palette.grey.main} !important`
      },
      '&.Mui-error fieldset': {
        borderColor: `${palette.bloodRed[100]} !important`
      },

      '&.Mui-focused fieldset': {
        borderColor: palette.primary['200'],
        color: `${palette.grey.main} !important`
      },
      '& input::placeholder': {
        /* Styles for placeholder text when there's no error */
        color: palette.grey.main
      },

      '&.Mui-error input::placeholder': {
        /* Styles for placeholder text when there's an error */
        color: palette.grey.main /* Set the color for the error state */
      }
    },
    '.MuiFormHelperText-root': {
      margin: '0',
      paddingTop: spacing(1),
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      color: palette.primary.main
    },
    // styles being applied at error state
    '& .Mui-error': {
      color: `${palette.bloodRed[100]} !important`,
      backgroundColor: 'transparent',
      '.MuiOutlinedInput-input': {
        color: `${palette.bloodRed[100]} !important`
      },
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${palette.bloodRed[100]} !important`
      },
      '&:hover fieldset': {
        borderColor: `${palette.bloodRed[100]} !important`
      },
      '&.Mui-focused fieldset': {
        borderColor: `${palette.bloodRed[100]} !important`
      }
    },
    // styles being applied at disabled state
    '.Mui-disabled': {
      '& svg path': {
        fill: `${palette.grey[400]} !important`
      },
      backgroundColor: `${palette.grey['100']} !important`,
      '.MuiOutlinedInput-input': {
        color: `${palette.darkestBlack.main} !important`,
        borderColor: `${palette.grey[300]} !important`,
        backgroundColor: `${palette.grey['100']} !important`,
        borderRadius: '0.25rem'
      },
      '&:hover fieldset': {
        borderColor: `${palette.grey[300]} !important`
      },
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${palette.grey[300]} !important`
      }
    }
  },

  hideNumberStepper: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  // styles applied for isSuccess
  isSuccess: {
    fontWeight: '500',
    fontSize: '0.875rem',
    lineHeight: '0.875rem',
    backgroundColor: palette.darkAqua.main,
    border: 'none',
    '& fieldset': {
      border: 'none'
    },
    '.MuiOutlinedInput-input': {
      color: palette.primary.main,
      zIndex: '100',
      border: 'none',
      borderRadius: '0.25rem',
      '&:hover': {
        color: palette.primary.main,
        border: 'none'
      },
      '&:focus': {
        color: palette.primary.main
      }
    }
  }
};

export default textFieldStyles;
